import React from 'react';
import { TextField, TextFieldHelperText } from 'rmwc/TextField'
import { Button } from 'rmwc/Button'
import { setUser, loadUserById, authUserUId, validUserProfile, getContinueUrl } from '../api/FirebaseAPI'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom';

class MyProfilePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      givenNames:undefined,
      familyName:undefined,
      contactNumber:undefined,
      businessName:undefined,
      email:undefined,
      disableButton:true,
      continueUrl:''
    }
    this.validate = this.validate.bind(this)
    this.handleDataChange = this.handleDataChange.bind(this)
    this.handleClick = this.handleClick.bind(this)
  }

  async componentDidMount() {
    if (authUserUId() !== null) {
      const id = authUserUId()
      const user = await loadUserById(id)
      this.setState({
        givenNames:user.givenNames,
        familyName:user.familyName,
        contactNumber:user.contactNumber,
        businessName:user.businessName,
        email:user.email
      })
    }

  }

  validate() {
    const mypofile = this.state
    if (mypofile.givenNames && mypofile.givenNames.length < 2) {
      this.setState({disableButton:true})
      return;
    }
    if (mypofile.familyName && mypofile.familyName.length < 2) {
      this.setState({disableButton:true})
      return;
    }
    if (mypofile.contactNumber && mypofile.contactNumber.length < 8) {
      this.setState({disableButton:true})
      return;
    }
    if (mypofile.businessName && mypofile.businessName.length < 2) {
      this.setState({disableButton:true})
      return;
    }
    this.setState({disableButton:false})
  }

  handleDataChange(e) {
    const target = e.target;
    const id = target.id;
    const value = target.value;
    this.setState({event:Object.assign(this.state, {[id]: value})}, () => {
      this.validate()
    });
  }

  async handleClick() {
    var user = {}
    if (this.state.givenNames) user['givenNames'] = this.state.givenNames
    if (this.state.familyName) user['familyName'] = this.state.familyName
    if (this.state.contactNumber) user['contactNumber'] = this.state.contactNumber
    if (this.state.businessName) user['businessName'] = this.state.businessName
    //console.log(this.state, user)
    setUser(user)
    const url = getContinueUrl(window.location.href)
    if (url) {
      this.props.history.replace(url)
    }
  }

  render() {
    if (authUserUId() === null) return <div>Loading...</div>

    const myprofile = this.state
    return (
      <div style={{paddingLeft:'10px', paddingRight:'10px'}}>
        <div style={{paddingTop:'50px'}}>
          My Profile - {myprofile.email}
        </div>
        <div>
          <TextField style={{minWidth:'300px'}} id='givenNames' label='First Name' required
            value={myprofile.givenNames || ''} onChange={this.handleDataChange}/>
          <TextFieldHelperText persistent validationMsg>The field is required.</TextFieldHelperText>
        </div>
        <div>
          <TextField  style={{minWidth:'300px'}} id='familyName' label='Last Name' required value={myprofile.familyName || ''} onChange={this.handleDataChange}/>
          <TextFieldHelperText persistent validationMsg>The field is required.</TextFieldHelperText>
        </div>
        <div>
          <TextField style={{minWidth:'300px'}} id='contactNumber' label='Contact Number' required value={myprofile.contactNumber || ''} onChange={this.handleDataChange}/>
          <TextFieldHelperText persistent validationMsg>The field is required to validate your profile.</TextFieldHelperText>
        </div>
        <div>
          <TextField style={{minWidth:'300px'}} id='businessName'  label='Business Name' required  value={myprofile.businessName || ''} onChange={this.handleDataChange}/>
          <TextFieldHelperText persistent validationMsg>The field is required for matching.</TextFieldHelperText>
        </div>
        <div style={{paddingTop:'20px'}}>
          <Button
            disabled={this.state.disableButton}
            raised
            onClick={this.handleClick}
          >Save</Button>
        </div>
      </div>
    );
  }
}

export default withRouter(MyProfilePage);

MyProfilePage.propTypes = {
  //email:PropTypes.string.isRequired
}

/*
disabled={this.state.disableButton}
*/



// WEBPACK FOOTER //
// ./src/containers/MyProfilePage.js